// Fetch list

export const FETCH = 'reportCustomerPlans.FETCH'
export const FETCH_STARTED = 'reportCustomerPlans.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportCustomerPlans.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportCustomerPlans.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportCustomerPlans.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportCustomerPlans.CLEAR'

// Export

export const EXPORT = 'reportCustomerPlans.EXPORT'
export const EXPORT_FULFILLED = 'reportCustomerPlans.EXPORT_FULFILLED'
